import Main from '@cmp/main';

function Empty(props) {
	let h = <h1 className="error-txt">Товар не найден!</h1>;
	return <Main>{h}</Main>;
}

export default Empty;
